import IdleModal from "./idleModal";

export default IdleModal;
